import React, { useMemo } from 'react';
import { getFlagAndDemonym } from 'utils';
import ToggleSwitch from './ToggleSwitch';
import style from './translation-on.module.css';
import classNames from 'classnames'

interface Props {
    language: string;
    on: boolean;
    onTurnOff(): void
}

const TranslationOn: React.FC<Props> = ({ language, on, onTurnOff }) => {

    const [flag, demonym] = useMemo(() => {
        return getFlagAndDemonym({
            targetLanguage: language
        })
    }, [language]);

    return (
        <div className={classNames({
            [style.translationAlert]: true,
            [style.off]: !on
        })}>
            <p><span className={style.flag}>{flag}</span>{`Auto-translation to ${demonym}`}</p>
            <div className={style.toggleControls}>
                <label>
                    {on ? 'On' : 'Off'}
                </label>
                <ToggleSwitch
                    on={on}
                    toggle={onTurnOff}
                />
            </div>

        </div>
    )
}

export default TranslationOn;